// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchTitle_root__OmyBw"};